// extracted by mini-css-extract-plugin
export default {"root":"GoogleButton_root__Y4Boh"};